import { make } from 'vuex-pathify';

const state = {
  tableHeight: 1,
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
